import React from "react";
import "./CmsActionModal.css";
import Button from "../Button/Button";
import logoSrc from "../../assets/logo-barterflip.svg";
const CmsActionModal = ({
  isOpen,
  onClose,
  // Header
  title,
  // Mensajes
  greeting,
  message,
  // Card de detalles
  details = [],
  // Botones (todos opcionales)
  showReject = false,
  rejectText = "Reject",
  onReject,
  showApprove = false,
  approveText = "Approve",
  onApprove,
  showMore = false,
  moreText = "More Details",
  onMore,

  // Estado
  loading = false,
  // estilo
  padding = "3rem 4rem",
}) => {
  if (!isOpen) return null;

  return (
    <div className="cms-modal-overlay" role="dialog" aria-modal="true">
      <div className="cms-modal-content" style={{ padding }}>
        <button
          className="cms-modal-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>
        {/* Header con logo */}
        <div className="cms-modal-header">
          {logoSrc && (
            <img src={logoSrc} alt="Barterflip" className="cms-modal-logo" />
          )}
          {title && <h2 className="cms-modal-title">{title}</h2>}
        </div>

        {/* Mensajes */}
        <div className="cms-modal-body">
          {greeting && <p className="cms-modal-greeting">{greeting}</p>}
          {message && <p className="cms-modal-message">{message}</p>}

          {/* Card (detalles) */}
          <div className="cms-details-card" aria-busy={loading}>
            {loading ? (
              <div className="cms-details-loading">Loading details…</div>
            ) : details?.length > 0 ? (
              <dl className="cms-details-list">
                {details.map((row, idx) => (
                  <div key={idx} className="cms-details-row">
                    <dt className="cms-details-label">{row.label}:</dt>
                    <dd className="cms-details-value">
                      {row.value.includes("_")
                        ? row.value.replace("_", " ")
                        : row.value}
                    </dd>
                  </div>
                ))}
              </dl>
            ) : (
              <div className="cms-details-empty">No details to display.</div>
            )}
          </div>
        </div>

        {/* Footer de acciones */}
        {(showReject || showApprove || showMore) && (
          <div className="cms-modal-actions">
            {showReject && (
              <Button
                type="button"
                variant="error"
                fullWidth
                onClick={onReject}
                disabled={loading}
              >
                {rejectText}
              </Button>
            )}
            {showApprove && (
              <Button
                type="button"
                variant="primary"
                fullWidth
                onClick={onApprove}
                disabled={loading}
              >
                {approveText}
              </Button>
            )}
            {showMore && (
              <Button
                type="button"
                variant="primary"
                fullWidth
                onClick={onMore}
                disabled={loading}
              >
                {moreText}
              </Button>
            )}
          </div>
        )}

        {/* Footer fijo */}
        <div className="cms-modal-footer">
          <div>We appreciate your support</div>
          <div className="cms-modal-brand">Barterflip Team</div>
        </div>
      </div>
    </div>
  );
};

export default CmsActionModal;
